import { siteConfig } from "@/mocks/categories";

const testimonials = [
  {
    quote: "The GTBuy spreadsheet completely changed how I shop online. I used to spend hours comparing products across different sites, but now I can see everything side by side in minutes. The comparison logic is incredibly intuitive and has saved me hundreds of dollars already.",
    name: "Sarah Mitchell",
    role: "Fashion Enthusiast & Frequent Shopper",
    image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20young%20woman%20with%20warm%20smile%20wearing%20casual%20beige%20blazer%20against%20soft%20grey%20studio%20background%20natural%20lighting%20clean%20editorial%20portrait%20photography%20minimal%20aesthetic%20friendly%20approachable%20expression&width=400&height=500&seq=testimonial-portrait-01&orientation=portrait",
  },
  {
    quote: "I have tried several comparison tools before, but none of them offered the flexibility and depth of GTBuy spreadsheet. The ability to customize comparison criteria for different product categories is a game-changer. My entire shopping workflow has become so much more efficient.",
    name: "Marcus Chen",
    role: "Tech Reviewer & Deal Hunter",
    image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20man%20in%20his%20thirties%20with%20confident%20expression%20wearing%20simple%20white%20shirt%20against%20soft%20neutral%20studio%20background%20natural%20lighting%20clean%20editorial%20portrait%20photography%20minimal%20aesthetic%20genuine%20smile&width=400&height=500&seq=testimonial-portrait-02&orientation=portrait",
  },
  {
    quote: "What sets GTBuy spreadsheet apart is the community behind it. The shared templates, tips, and comparison frameworks make it easy to get started and continuously improve your shopping strategy. It is not just a tool—it is a complete methodology.",
    name: "Emma Rodriguez",
    role: "Budget-Conscious Parent & Smart Shopper",
    image: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20woman%20with%20warm%20genuine%20smile%20wearing%20cream%20sweater%20against%20soft%20studio%20background%20natural%20lighting%20clean%20editorial%20portrait%20photography%20minimal%20aesthetic%20friendly%20relaxed%20expression&width=400&height=500&seq=testimonial-portrait-03&orientation=portrait",
  },
];

export default function TestimonialSection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-medium text-foreground-500 uppercase tracking-widest font-[family-name:var(--font-label)]">
            What Users Say
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 mt-2 font-[family-name:var(--font-heading)]">
            Loved by <span className="italic">Smart Shoppers</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/60 flex flex-col"
            >
              <div className="text-5xl text-accent-300 font-[family-name:var(--font-heading)] mb-4 leading-none">
                &ldquo;
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1 mb-6 font-[family-name:var(--font-body)] font-light">
                {t.quote}
              </p>
              <div className="flex items-center gap-4 pt-4 border-t border-background-200/50">
                <img
                  src={t.image}
                  alt={t.name}
                  title={`${t.name} - ${t.role}`}
                  className="w-12 h-12 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-950 font-[family-name:var(--font-label)]">
                    {t.name}
                  </div>
                  <div className="text-xs text-foreground-500 font-[family-name:var(--font-body)]">
                    {t.role}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}